const honorcategory = {
  getlist: 'honorcategory/getlist-by-admin',
  add: 'honorcategory/add',
  update: 'honorcategory/update',
  remove: 'honorcategory/remove',
  get: 'honorcategory/get',
  getall: 'honorcategory/getall-by-admin',
  clearcache: 'honorcategory/clear-cache',
}
export default honorcategory
